import {createSso, SSO} from "@rockr/sso"
import {Env} from "@rockr/sso/dist/shared/types/env";

const SSO_ENV: Env = (process.env.REACT_APP_SSO_ENV || "dev") as Env

let ssoClient: SSO;

export const getSSOClient = () => {
  if (!ssoClient) ssoClient = createSso(SSO_ENV)

  return ssoClient;
}
